import React, { useState } from 'react';
import {
  Input,
  InputGroup,
  InputLeftElement
} from '@chakra-ui/react';
import { LuSearch } from 'react-icons/lu';
import ChannelPartnerTable from '../components/ChannelPartnerTable';

const FinanceDashboardHome = () => {
  const [searchQuery, setSearchQuery] = useState("");
  const role = localStorage.getItem('authRole');

  return (
    <div className="bg-[#F3F4F6] h-screen">
      <p className="font-semibold mx-8 my-4 text-[20px]">Channel Partners</p>

      <div className="bg-white mx-8 my-4 p-4 rounded-md shadow-sm">

        
        {['finance_user', 'wallet_superadmin', 'wallet_finance'].includes(role) && <div className='flex gap-4 justify-end'>
          <div>
            <InputGroup w="250px">
              <InputLeftElement pointerEvents="none">
                <LuSearch color="gray" />
              </InputLeftElement>
              <Input
                placeholder="Search channel partners"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </InputGroup>
          </div>
          {/* <div>
            <div className='bg-[#F0F6FE] flex h-full text-[#233B85] font-[500]'>
              <p className='flex gap-2 items-center px-4'> <GoPlusCircle color='#233B85' /> Add New Channel Partner Wallet </p>
            </div>
          </div> */}
        </div>}
        <div className='my-8 '>
          <ChannelPartnerTable searchQuery={searchQuery} />
        </div>
        {/* <div className='flex justify-end mx-4 my-4'>
          <div className='bg-[#F0F6FE] flex h-full text-[#233B85] font-[500] w-[150px] justify-center items-center'>
            <p className='flex gap-2 items-center justify-center px-2 py-2'>Export Report </p>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default FinanceDashboardHome;
